module.exports = __webpack_public_path__ + "img/app_logo.535f8629.png";